import React from 'react';
import Button from '@mui/material/Button';
import ItemFormModal from './ItemFormModal';
import { Box, FormHelperText } from '@mui/material';

const AddLineItemButton = ({ errors, addItem, buttonText = '+ Add Line Item', name = 'item_details' }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" gap={1}>
        <Button id="add-line-item" variant="contained" onClick={handleOpen}>
          {buttonText}
        </Button>
        {errors[name] && (
          <FormHelperText error sx={{ m: 0 }}>
            {errors[name]?.message}
          </FormHelperText>
        )}
      </Box>
      <ItemFormModal open={open} handleClose={handleClose} handleSubmit={addItem} />
    </React.Fragment>
  );
};

export default AddLineItemButton;
